import { deleteOrganizationById } from "@/api";
import { DestructiveDialog } from "@/components/shared/dialogs/destructive-dialog/DestructiveDialog";
import { Delete } from "@mui/icons-material";
import { GridActionsCellItem } from "@mui/x-data-grid-pro";
import { useQueryClient } from "@tanstack/react-query";
import { useDialogs } from "@toolpad/core";

interface Props {
    organizationId: number;
}

export const DeleteOrganizationButton = ({ organizationId }: Props) => {
    const dialogs = useDialogs();
    const queryClient = useQueryClient();

    const handleDelete = async () => {
        await dialogs.open(DestructiveDialog, {
            itemId: organizationId,
            subject: "organization",
            mutationFn: deleteOrganizationById,
            onSucceeded: () => {
                queryClient.invalidateQueries({
                    queryKey: ["admin-organizations"],
                });
            },
        });
    };

    return (
        <GridActionsCellItem
            icon={<Delete />}
            label="Delete Organization"
            onClick={handleDelete}
        />
    );
};
